import React from 'react';

import * as ArchiveActions from 'archive/ArchiveActions';
import ArchiveModal from 'archive/components/modals/ArchiveModal';
import isArchived from 'archive/isArchived';
import {InventoryFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';
import * as ExportConstants from 'constants/ExportConstants';
import {RegistrySummary} from 'constants/RegistryConstants';
import {Location} from 'constants/SampleConstants';
import ExportModal from 'exports/ExportModal';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import PrintBarcodeModal from 'label-printing/PrintBarcodeModal';
import navigateToURL from 'lib/navigateToURL';
import * as RegistryUtil from 'registry/RegistryUtil';
import runModal from 'ui-library/runModal';

import SettingsIconDropdown from '../SettingsIconDropdown';

interface Props {
  location: Location | null;
  registry: RegistrySummary;
  iconClassName?: string;
}

class StorableSettingsIcon extends React.Component<Props> {
  private handleOpenExportModal = (): void => {
    ExportModal.open({exportType: ExportConstants.TYPE.REGISTRY, registry: this.props.registry});
  };

  private getRegistrySettingsURL = (): string =>
    RegistryUtil.getRegistrySettingsUrl(this.props.registry.s_owner.url_identifier, this.props.registry.id);

  private handleOpenRegistrySettings = (): void => {
    const settingsURL = this.getRegistrySettingsURL();
    navigateToURL(settingsURL);
  };

  private handleUnarchive = (): void => {
    ArchiveActions.bulkUnarchiveStorablesWithDataMods([this.props.location!.id]);
  };

  private handleOpenArchiveModal = (): void => {
    runModal(ArchiveModal, {
      items: [this.props.location!],
      onArchive: ArchiveActions.bulkArchiveStorablesWithDataMods,
    });
  };

  private handleOpenPrintBarcodesModal = (): void => {
    runModal(PrintBarcodeModal, {itemIds: [this.props.location!.id]});
  };

  override render(): JSX.Element {
    const options = [];
    if (this.props.location) {
      const permissions = this.props.location.permissions;
      options.push({
        name: 'Open location',
        onSelect: () => {
          FileBrowserActions.openFile(this.props.location!.id);
        },
      });
      if (permissions.archivable && !isArchived(this.props.location)) {
        options.push({
          name: 'Archive location',
          onSelect: this.handleOpenArchiveModal,
        });
      }
      if (isArchived(this.props.location) && this.props.location.permissions.unarchivable) {
        options.push({
          name: 'Unarchive location',
          onSelect: this.handleUnarchive,
        });
      }
      if (isFeatureEnabled({feature: InventoryFeature.INVENTORY_EXPORT})) {
        options.push({
          name: 'Print label',
          onSelect: this.handleOpenPrintBarcodesModal,
        });
      }
    }
    options.push({
      name: 'Registry settings',
      onSelect: this.handleOpenRegistrySettings,
      href: this.getRegistrySettingsURL(),
    });
    if (BenchlingConfig.ENABLE_EXPORTS) {
      options.push({
        name: 'Export registry',
        onSelect: this.handleOpenExportModal,
      });
    }
    return <SettingsIconDropdown options={options} iconClassName={this.props.iconClassName} />;
  }
}

export default StorableSettingsIcon;
